<template>
  <div class="cas">
    <p v-if="!val1" class="cas-placeholder">请选择{{placehold}}</p>
    <Dropdown
      @on-click="_clickMenu"
      transfer-class-name="c-cas-dropdown"
      placement="bottom-end"
      :stop-propagation="true"
      :transfer="true"
      style="width:100%;"
      trigger="custom"
      :visible="isFocus"
    >
      <div
        v-click-outside.capture="_clickOutside"
        @click.stop="_casClick"
        class="cas-input"
        :class="{'cas-focus': isFocus}"
      >
        <div class = 'cas-input-content'>
          <Tooltip :disabled = '!val1' placement="top" :content="`${val1}${val2?' / '+val2:''}${val3?' / '+val3:''}`" :delay="1000">
            <span>{{val1}}</span>
            <span v-if="val2" style="padding:5px;">/</span>
            <span>{{val2}}</span>
            <span v-if="val3" style="padding:5px;">/</span>
            <span>{{val3}}</span>
          </Tooltip>
        </div>
        <CIcon v-if="val1" @click="reset" class="reset-icon" icon="zhuangtai-cuowu" size="12"></CIcon>
      </div>
      <DropdownMenu slot="list">
        <div style="display:flex;">
          <div
            v-if="list1.length"
            style="min-width:100px;padding:5px;max-height:200px;overflow-y:auto;"
          >
            <DropdownItem
              :selected="(val1!=''&&(item.label == val1))"
              :name="JSON.stringify(item)"
              v-for="(item,index) in list1"
              :key="index"
            >
              {{item.label}}
              <CIcon style="float:right;" icon="tupianyulan-fankanhouyizhang" size="12"></CIcon>
            </DropdownItem>
          </div>
          <div
            v-if="list2.length"
            style="min-width:100px;border-left:1px solid #eee;border-right:1px solid #eee;padding:5px;max-height:200px;overflow-y:auto;"
          >
            <DropdownItem
              :selected="(val2!=''&&(item1.label == val2))"
              :name="JSON.stringify(item1)"
              v-for="(item1,index) in list2"
              :key="index"
            >
              {{item1.label}}
              <CIcon v-if="list3.length" style="float:right;" icon="tupianyulan-fankanhouyizhang" size="12"></CIcon>
            </DropdownItem>
          </div>
          <div
            v-if="list3.length"
            style="min-width:100px;padding:5px;max-height:200px;overflow-y:auto;"
          >
            <DropdownItem
              :selected="(val3!=''&&(item2.label == val3))"
              :name="JSON.stringify(item2)"
              v-for="(item2,index) in list3"
              :key="index"
            >{{item2.label}}</DropdownItem>
          </div>
        </div>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>
<script>
import _areaList from '@/assets/address.js'
import { directive as clickOutside } from 'v-click-outside-x'
export default {
  props: {
    value: [],
    placehold: String
  },
  data() {
    return {
      val1: '',
      val2: '',
      val3: '',
      _casdata: [],
      isFocus: false,
      list1: [],
      list2: [],
      list3: []
    }
  },
  directives: {
    clickOutside
  },
  created() {
    this._casdata = _areaList.data
    this.getList1()
    this.resizeEvent = new Event('resize')
  },
  mounted() {
    document.addEventListener('click', () => {
      if (this.isClickMenu) {
        this.isClickMenu = false
      } else {
        this.isFocus = false
      }
    })
  },
  methods: {
    setData(val) {
      if (val && val[0]) {
        this._check1(val[0],true)
      }
      if (val && val[1]) {
        this._check2(val[1],true)
      }
      if (val && val[2]) {
        this._check3(val[2])
      }
    },
    reset() {
      this.val1 = ''
      this.val2 = ''
      this.val3 = ''
      this.list2 = []
      this.list3 = []
      this.$emit('change', [this.val1, this.val2, this.val3])
    },
    _clickMenu(item) {
      this.isFocus = true
      this.isClickMenu = true
      let _item = JSON.parse(item)
      if (_item.index == 0) {
        this._check1(_item.label)
      } else if (_item.index == 1) {
        this._check2(_item.label)
      } else if (_item.index == 2) {
        this._check3(_item.label)
      }
    },
    _check1(val,noShow) {
      this.val1 = val
      this.val2 = ''
      this.val3 = ''
      this.$emit('change', [this.val1, this.val2, this.val3])
      this.getList2(val)
      this.isFocus = false
      this.$nextTick(()=>{
        if(!noShow){
          this.isFocus = true
        }
        this.triggerResize()
      })
    },
    _check2(val,noShow) {
      this.val2 = val
      this.val3 = ''
      this.$emit('change', [this.val1, this.val2, this.val3])
      this.getList3(val)
      this.isFocus = false
      this.$nextTick(()=>{
        if(!noShow){
          this.isFocus = true
        }
        this.triggerResize()
      })
    },
    _check3(val) {
      this.val3 = val
      this.$emit('change', [this.val1, this.val2, this.val3])
    },
    triggerResize(){
      window.dispatchEvent(this.resizeEvent)
    },
    getList1() {
      this.list1 = []
      this.list2 = []
      this.list3 = []
      for (let i in this._casdata) {
        this.list1.push({
          value: this._casdata[i].value,
          label: this._casdata[i].label,
          index: 0
        })
      }
    },
    getList2(val) {
      this._dg(val, this._casdata, item => {
        if (item && item.length) {
          this.list2 = []
          this.list3 = []
          for (let i in item) {
            this.list2.push({
              value: item[i].value,
              label: item[i].label,
              index: 1
            })
          }
        }
      })
    },
    getList3(val) {
      this._dg(val, this._casdata, item => {
        this.list3 = []
        if (item && item.length) {
          for (let i in item) {
            this.list3.push({
              value: item[i].value,
              label: item[i].label,
              index: 2
            })
          }
        }
      })
    },
    _dg(val, arr, cb) {
      for (let i in arr) {
        if (val === arr[i].value) {
          cb && cb(arr[i].children)
          return
        } else {
          if (arr[i].children && arr[i].children.length) {
            this._dg(val, arr[i].children, cb)
          }
        }
      }
    },
    _clickOutside() {
      // this.isFocus = false
    },
    _casClick() {
      this.isFocus = true
    }
  }
}
</script>

<style lang = "less" scoped>
.cas {
  position: relative;
  height: 36px;
  .cas-placeholder {
    position: absolute;
    width:90%;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 8px;
    color: #c5c8ce;
  }
  .cas-input {
    height: 36px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    width: 100%;
    cursor: text;
    transition: 0.2s;
    line-height: 36px;
    padding-left: 10px;
    box-sizing:border-box;
    &:hover {
      border: 1px solid #04cbdb;
    }
    .reset-icon{
      float:right;
      margin-right:8px;
      cursor: pointer;
    }
    .cas-input-content{
      width: calc(100%-50px);
      display:inline-block;
    }
  }
  .cas-input-content /deep/ .ivu-tooltip{
    width: 100%;
  }
  .cas-input-content /deep/ .ivu-tooltip-rel{
    width:100%;
    overflow:hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display:inline-block;
  }
  .cas-focus {
    border: 1px solid #04cbdb !important;
  }
}
</style>